












import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { SnackbarInterface } from "../../store/snackbar/state";

const snackStore = namespace("snackbar");

@Component
export default class SnackbarStore extends Vue {
  @snackStore.Getter snackbar!: SnackbarInterface;

  @snackStore.Mutation setSnackbarVisibility!: (payload: boolean) => void;

  closeSnackbar(): void {
    this.setSnackbarVisibility(false);
  }

  get isMultiline(): boolean {
    return this.snackbar.text !== undefined && this.snackbar.text.length > 50;
  }
}
